import { PlacePrediction } from './types';
import { getPlacePredictions } from './GoogleApis';

/**
 * -- Address Predictions Semaphore Pattern --
 * We will get errors if we hit google too often
 * There is no point to hitting google with not enough information
 * There is not point in asking for information twice
 */
let lastCallOut: null | number = null; // Flag to allow the next call
let lastResult: PlacePrediction[] = []; // This is to allow us to send back the last good result if there is an error, or if the string is close to the same: IE "12345 West" and "12345 West "
let lastAddress = ''; // Sent when a callback is fired so we get the most up to date information
export const locationCallBacks: Function[] = []; // Callback Queue

// Getters and setters are to ease in testing and linting
export function setLastCallOut(val: null | number) {
  lastCallOut = val;
}
export function getLastCallOut() {
  return lastCallOut;
}

// Getters and setters are to ease in testing and linting
export function setLastAddress(val: string) {
  lastAddress = val;
}
export function getLastAddress() {
  return lastAddress;
}

// Getters and setters are to ease in testing and linting
export function setLastResult(result: PlacePrediction[]) {
  lastResult = result;
}
export function getLastResult() {
  return lastResult;
}

export function resolveLocations(results: PlacePrediction[], resolve: Function) {
  setLastCallOut(null); // Clear the semaphore
  // Call the next in line
  const callBack = locationCallBacks.shift();
  if (callBack) {
    callBack();
  }
  setLastResult(results); // set the last good results
  resolve(results);
}

export function getLocationsPromise(addressString: string): Promise<PlacePrediction[]> {
  return new Promise(resolve => {
    setLastCallOut(Date.now()); // Flag the next call to wait

    getPlacePredictions(addressString) // Query the address
      .then((results: PlacePrediction[]) => resolveLocations(results, resolve))
      .catch(() => resolveLocations(lastResult, resolve)); // On error resolve the last good array
  });
}

export function getLocationsByAddress(addressString: string): Promise<PlacePrediction[]> {
  const now = Date.now();
  const changed = addressString.trim() !== lastAddress.trim();
  setLastAddress(addressString);
  let promise: Promise<PlacePrediction[]>;
  // Don't even bother with google if the address has not changed, or is less then 5 characters
  if (!changed || addressString.length <= 5) {
    promise = Promise.resolve(lastResult);
  } else if (lastCallOut && now - lastCallOut <= 2000) {
    promise = new Promise(resolve => {
      // Register Callback
      locationCallBacks.push(() => getLocationsPromise(lastAddress).then(resolve));
    });
  } else {
    promise = getLocationsPromise(addressString);
  }

  return promise;
}
// End -- Semaphore Pattern --
